export default __webpack_public_path__ + "static/media/PPT_2024_02_28.87a052de.pptx";